import { render, staticRenderFns } from "./ageSignNew.vue?vue&type=template&id=40a868f8&scoped=true&"
import script from "./ageSignNew.vue?vue&type=script&lang=js&"
export * from "./ageSignNew.vue?vue&type=script&lang=js&"
import style0 from "./ageSignNew.vue?vue&type=style&index=0&id=40a868f8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a868f8",
  null
  
)

export default component.exports